import { useMediaQuery } from '@mui/material';
import PasswordResetAmplify from 'features/Authentication/PasswordReset';
import AuthLayout from 'layouts/AuthLayout';
import theme from 'themes';

const PasswordReset = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <AuthLayout title='Change Password' isMobile={isMobile}>
      <PasswordResetAmplify />
    </AuthLayout>
  );
};

export default PasswordReset;
